// extracted by mini-css-extract-plugin
export default {"products":"Yy-z","card":"Zy-z","oosMessaging":"_y-z"};